import React from 'react';
import { Pivot, PivotItem } from '@fluentui/react';
import PowerPlatformItemsList from './PowerPlatformItemsList';
import EnvironmentsRolesList from './EnvironmentsRolesList';
import { addPivotItemKeyToUrl, getPivotItemKeyFromUrl } from '../../../helpers/HelperMethods';
import PowerPlatformSolutionsList from './PowerPlatformSolutionsList';
import EnvironmentsList from './EnvironmentsList';

export const PowerPlatformPanel = ({ parentPivotKey }) => {

    const defaultSelectedKey = getPivotItemKeyFromUrl('Environments', parentPivotKey);

    return (
        <Pivot styles={pivotStyles} defaultSelectedKey={defaultSelectedKey} onLinkClick={addPivotItemKeyToUrl(parentPivotKey)}>
            <PivotItem itemKey='Environments' headerText='Environments'>
                <EnvironmentsList />
            </PivotItem>
            <PivotItem itemKey='Solutions' headerText='Solutions'>
                <PowerPlatformSolutionsList />
            </PivotItem>
            <PivotItem itemKey='AppsAndFlows' headerText='Apps & Flows & Agents'>
                <PowerPlatformItemsList />
            </PivotItem>
            <PivotItem itemKey='Roles' headerText='Environments Roles'>
                <EnvironmentsRolesList />
            </PivotItem>
        </Pivot>
    );
};

const pivotStyles = {
    root: {
        marginBottom: 20
    },
    linkContent: {
        fontSize: 16,
        flex: 'auto'
    }
}



// WEBPACK FOOTER //
// ./src/components/Administration/PowerPlatform/PowerPlatformPanel.js